import "./App.css";
import React from "react";
import Router from "./router";

function App(): JSX.Element {
    return <Router />;
}

export default App;
